import React from "react";
import AppModal from "../../common/AppModal";
import { Alert } from "@mui/material";
import CreateOrUpdateFiscalItemForm from "../../../forms/CreateOrUpdateFiscalItemForm";

const UpdateFiscalItemModal = ({ open, onClose, item, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    loading={loading}
    title="Update eTIMS Item Configuration"
    width="sm"
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateFiscalItemForm
      item={item}
      isEditing={true}
      loading={loading}
    />
  </AppModal>
);

export default UpdateFiscalItemModal;
